import service from '../../config/axios.config';

const getEndpoint = managerialDecisionId =>
  `/managerialDecisions/${managerialDecisionId}/comments`;

export const createComment = ({ managerialDecisionId, content }) =>
  service.post(getEndpoint(managerialDecisionId), { content });

export const fetchCommentsOfDecision = managerialDecisionId =>
  service.get(getEndpoint(managerialDecisionId));

export const updateComment = ({ managerialDecisionId, commentId, content }) =>
  service.put(`${getEndpoint(managerialDecisionId)}/${commentId}`, { content });

export const deleteComment = ({ managerialDecisionId, commentId }) =>
  service.delete(`${getEndpoint(managerialDecisionId)}/${commentId}`);